import { cva } from 'class-variance-authority';
import { interactiveBase, focusRing, transitionColors } from '@/lib/styleUtils';

export const tabVariants = cva(
  // Base classes
  [interactiveBase, focusRing, transitionColors, 'tw:bg-transparent tw:relative tw:flex-1'].join(
    ' '
  ),
  {
    variants: {
      tabType: {
        line: 'tw:border-0 tw:border-solid tw:border-b',
        box: 'tw:border-0',
      },
      size: {
        small: 'tw:text-14 tw:font-regular tw:leading-[1.125] tw:p-micro tw:gap-micro',
        medium: 'tw:text-16 tw:font-regular tw:leading-1 tw:py-small tw:px-micro tw:gap-micro',
      },
      isActive: {
        true: '',
        false: '',
      },
      hasTopIcon: {
        true: 'tw:flex-col',
        false: '',
      },
    },

    compoundVariants: [
      // ===========================================
      // LINE TYPE - Active/Inactive (indicator provides underline)
      // ===========================================
      {
        tabType: 'line',
        isActive: true,
        className: ['tw:text-primary tw:!font-bold', 'tw:border-b-2 tw:border-transparent'].join(
          ' '
        ),
      },
      {
        tabType: 'line',
        isActive: false,
        className: [
          'tw:text-gray-darker',
          'tw:border-gray-lighter tw:transition-colors tw:duration-150',
          'tw:hover:text-gray-darker tw:hover:border-gray',
        ].join(' '),
      },

      // ===========================================
      // BOX TYPE - Active/Inactive (indicator provides active pill)
      // ===========================================
      {
        tabType: 'box',
        isActive: true,
        className: 'tw:text-font tw:!font-bold tw:bg-transparent tw:rounded-8',
      },
      {
        tabType: 'box',
        isActive: false,
        className:
          'tw:text-gray-dark tw:bg-gray-lighter tw:hover:text-gray-darker tw:hover:bg-gray-light tw:rounded-8',
      },
    ],

    defaultVariants: {
      tabType: 'line',
      size: 'medium',
      isActive: false,
      hasTopIcon: false,
    },
  }
);

export const tabDisabledClasses =
  'tw:disabled:cursor-not-allowed tw:disabled:pointer-events-none tw:disabled:opacity-40';

// ===========================================
// CONTAINER VARIANTS
// ===========================================

export const lineContainerClasses =
  'tw:flex tw:items-stretch tw:w-full tw:overflow-x-auto tw:scrollbar-hide';

export const boxContainerClasses =
  'tw:flex tw:w-full tw:items-stretch tw:bg-gray-lighter tw:border tw:border-solid tw:border-gray-light tw:rounded-8 tw:p-nano tw:gap-micro tw:overflow-x-auto tw:scrollbar-hide';

/** Box type: tablist only (no bg/border/rounded/padding; outer wrapper has tray styles). */
export const boxTablistClasses =
  'tw:flex tw:w-full tw:items-stretch tw:gap-micro tw:overflow-x-auto tw:scrollbar-hide';

/** Box type: tray styles for the outer wrapper (so indicator is visible behind transparent tablist). */
export const boxTrayClasses =
  'tw:bg-gray-lighter tw:border tw:border-solid tw:border-gray-light tw:rounded-8 tw:p-nano';
